import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    role: "admin",
    userAdmin: false,
    id: null,
};

export const userStore = createSlice({
    name: "userStore",
    initialState,
    reducers: {
        loadRoleState: (state, action) => {
            state.role = action.payload;
        },
        loadUserAdminState: (state, action) => {
            state.userAdmin = action.payload;
        },
        loadIdState: (state, action) => {
            state.id = action.payload;
        },
        loadValueState: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { loadRoleState, loadUserAdminState, loadIdState } = userStore.actions;

export default userStore.reducer;
